import { action, computed, makeObservable, observable } from 'mobx';
import { isTargetScrolledToBottom } from '../../core';
import { Store } from '../../store/store';
import { BindingProps, refProxy, StoreNode } from '../../store';
import { SyncStatus } from '../../store/syncSchema';
import { CarouselState } from './carouselCatalogState';

type Props = BindingProps<{
  syncStatus?: SyncStatus,
  isEndOfList?: boolean,
  viewType?: ViewType,
}>
type ViewType = 'grid' | 'list';

/**
 * Controller for catalogs with infinite scroll.
 */
export class CatalogState
  extends StoreNode {

  constructor(store: Store, props?: Props) {
    super(store, props);
    makeObservable(this, {
      syncStatus: computed,
      isEndOfList: computed,
      scrollToBottomThreshold: observable,
      isScrolledToBottom: observable,
      viewType: observable,
      isLoading: computed,
      isLoadingMore: computed,
      handleScroll: action,
      handleScrollToBottom: action,
      handleLoadMoreButtonClick: action,
      loadMore: action,
      toggleViewType: action,
    });

    this.viewType = props?.viewType as ViewType || 'grid';
  }

  get syncStatus(): SyncStatus {
    return this.resolvedProps.syncStatus;
  }

  get isEndOfList(): boolean {
    return this.resolvedProps.isEndOfList;
  }

  readonly domContainer = refProxy(this);
  readonly carouselState = new CarouselState(this)

  scrollToBottomThreshold = 20;
  isScrolledToBottom = false;
  viewType: ViewType = 'grid';

  get isLoading() {
    return this.syncStatus === 'fetching';
  }
  get isLoadingMore() {
    return this.syncStatus === 'fetchingMore';
  }

  handleScroll = (evt: React.SyntheticEvent) => {

    const prevToBottom = this.isScrolledToBottom;
    const currToBottom = isTargetScrolledToBottom(
      this.domContainer, this.scrollToBottomThreshold);

    if (prevToBottom !== currToBottom) {
      if (currToBottom)
        this.handleScrollToBottom(evt);

      this.isScrolledToBottom = currToBottom;
    }
  }

  handleScrollToBottom = (_evt: React.SyntheticEvent) => {
    this.emit('scrollToBottom');
  }

  handleLoadMoreButtonClick = (_evt: React.MouseEvent) => {
    this.emit('loadMore');
  }

  loadMore() {
    this.emit('loadMore');
  }

  toggleViewType() {
    if (this.viewType === 'grid') {
      this.viewType = 'list';
    } else {
      this.viewType = 'grid';
    }
  }
}

